import { Media } from '../../media';
import { IssueMessageType } from '../../graphql';

export type NewMessage = {
  message: string;
  media?: Media[];
  // Side Chat (plan 0022): when set, the created message is parented to
  // `parentMessage.id` and routed into that message's side chat instead of the
  // main thread.
  parentMessage?: { id: string };
  // Optional override for the message type. Defaults to USER_MESSAGE; the side
  // chat divider is created as SYSTEM_MESSAGE.
  type?: IssueMessageType;
};
